import React, { useEffect, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { importFactureAdded } from "../../Redux/importFactureReduce";
import { useTranslation } from "react-multi-lang";
import { useDispatch } from "react-redux";
import { verification } from "../../Redux/usersReduce";
import { fetchGrossisteClient } from "../../Redux/grossisteReduce";
import { fetchGrossisteFacture } from "../../Redux/factureReduce";
import Swal from 'sweetalert2';


function AjouterImportFacture({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  const annee = localStorage.getItem("annee");

  if (isNaN(location.id) === true) document.title = t("ImportFacture.add");

  // State
  const [optionGrossiste, setOptionGrossiste] = React.useState([]);
  const [optionFacture, setOptionFacture] = React.useState([]);
  const [clientNom, setClientNom] = React.useState(null);
  const [date, setDate] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const [factureFiles, setFactureFiles] = React.useState([]); // multiple rows

  // Toast helper
  const notify = (type, msg) => {
    if (type === 1) toast.success(<strong>{msg}</strong>);
    else toast.error(<strong>{msg}</strong>);
  };

  // Récupérer la liste des grossistes
  const getGrossiste = useCallback(async () => {
    const type = await dispatch(fetchGrossisteClient({ id_site: client === "/medis" ? 2 : 3 }));
    const entities = type.payload;
    const arrayOption = entities.map((e) => ({
      value: e.id_grossiste,
      label: e.code + ":" + e.raison_sociale,
      raison_sociale: e.raison_sociale,
      code: e.code,
    }));
    setOptionGrossiste(arrayOption);
  }, [dispatch, client]);

  // Récupérer factures par client
  const getFacture = useCallback(
    async (code_client) => {
      const type = await dispatch(fetchGrossisteFacture({ code_client, client }));
      const entities = type.payload;
      const arrayOption = entities.map((e) => ({
        value: e.NumFacture,
        id: e.NumFacture,
        label: e.NumFacture,
        fileExists: e.fileExists
      }));
      setOptionFacture(arrayOption);
    },
    [dispatch, client]
  );

  // Token verification
  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then((e) => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      });
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }
  }, [dispatch]);

  // Form submission
  const isSubmitting = useRef(false);

  const submitForm = async () => {
    if (isSubmitting.current) return;

    if (!date || !clientNom || factureFiles.length === 0) {
      toast.error("Veuillez remplir tous les champs obligatoires !");
      return;
    }

    for (const f of factureFiles) {
      if (!f.numFacture) {
        toast.error("Chaque ligne doit avoir un numéro de facture et un fichier !");
        return;
      }
    }
    const formData = new FormData();
    var factureNonPDF = []
    formData.append("date", date);
    formData.append("client", client);
    formData.append("clientNom", clientNom?.raison_sociale || "");
    formData.append("id_grossiste", clientNom?.value || "");
    formData.append("clientCode", clientNom?.code || "");

    factureFiles.forEach((f, index) => {
      formData.append(`files`, f.file);
      formData.append(`numFactures[${index}]`, f.numFacture.value);
      formData.append(`idFactures[${index}]`, f.numFacture.id);
      if (f.numFacture.fileExists == false) {
        factureNonPDF.push(f.numFacture.value)
      }
    });
    let continuerSave = 0;
    const resultSwal = await Swal.fire({
      title: 'Factures sans PDF détectées',
      text: factureNonPDF.length > 0
        ? `Les factures suivantes n’ont pas de PDF : ${factureNonPDF.join(', ')}`
        : "Voulez-vous continuer ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    });

    if (resultSwal.isConfirmed) {
      continuerSave = 1;
    }

    setLoader(true);
    if (continuerSave == 1) {
      isSubmitting.current = true;


      try {
        const result = await dispatch(importFactureAdded(formData));
        if (result.payload && result.payload.files) {
          toast.success("Fichiers enregistrés avec succès !");
          setTimeout(() => {
            window.location.replace(client + "/listImportFacture");
          }, 800);
        } else {
          toast.error("Impossible de récupérer les fichiers enregistrés.");
        }
      } catch (error) {
        toast.error("Erreur lors de l'enregistrement des fichiers.");
      } finally {
        isSubmitting.current = false;
        setLoader(false);
      }
    }
  };

  // Dynamic rows handlers
  const addRow = () => {
    setFactureFiles([...factureFiles, { numFacture: null, file: null }]);
  };

  const removeRow = (index) => {
    const newFactureFiles = [...factureFiles];
    newFactureFiles.splice(index, 1);
    setFactureFiles(newFactureFiles);
  };

  const handleNumFactureChange = (index, value) => {
    const newFactureFiles = [...factureFiles];
    newFactureFiles[index].numFacture = value;
    setFactureFiles(newFactureFiles);
  };

  const handleFileChange = (index, file) => {
    const newFactureFiles = [...factureFiles];
    newFactureFiles[index].file = file;
    setFactureFiles(newFactureFiles);
  };

  // Navigate to list
  function listeImportFacture() {
    navigate.push(client + "/listImportFacture");
  }

  useEffect(() => {
    verifToken();
    getGrossiste();
  }, [location.id, dispatch, navigate, getGrossiste, verifToken]);

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeImportFacture}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form className="form">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      Import Facture
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <label>Client *</label>
                          <Select
                            placeholder="Client"
                            className="react-select"
                            value={clientNom}
                            onChange={(value) => {
                              setClientNom(value);
                              getFacture(value.code);
                            }}
                            options={optionGrossiste}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <label>Date d'enlevement *</label>
                          <Form.Control
                            value={date || ""}
                            placeholder="Date"
                            type="date"
                            onChange={(e) => setDate(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <hr />

                    <Row>
                      <Col md="12">
                        <h5>Factures et fichiers</h5>
                        {factureFiles.map((item, index) => (
                          <Row key={index} className="mb-2 align-items-center">
                            <Col md="5">
                              <Select
                                placeholder="Facture"
                                className="react-select"
                                value={item.numFacture}
                                onChange={(value) => handleNumFactureChange(index, value)}
                                options={optionFacture}
                              />
                            </Col>
                            <Col md="5">
                              <Form.Control
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => handleFileChange(index, e.target.files[0])}
                              />
                            </Col>
                            <Col md="2">
                              <Button variant="danger" onClick={() => removeRow(index)}>
                                Supprimer
                              </Button>
                            </Col>
                          </Row>
                        ))}
                        <Button variant="info" onClick={addRow}>
                          Ajouter une ligne
                        </Button>
                      </Col>
                    </Row>

                    <br />
                    {!loader ? (
                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={submitForm}
                      >
                        {t("save")}
                      </Button>
                    ) : (
                      <div className="pull-right text-info font-weight-bold">
                        ⏳ Enregistrement en cours...
                      </div>
                    )}

                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterImportFacture;
